<template>
    <div>
        <!-- <button @click="openModal">open</button> -->
        <div  :class="{ active: showModal, inactive: !showModal }" class="job_modal">
            
                <div class="p-2 pt-3 d-flex align-item-center justify-content-between">
                    <div class="d-flex align-items-center mb-0" v-if="job_detail.status_id == 1">
                        <img src="../assets/img/check.png" alt="" class="">
                        <span class="status_text text-danger">{{ job_detail.statusname }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-0" v-else-if="job_detail.status_id == 2">
                        <img src="../assets/img/check.png" alt="" class="">
                        <span class="status_text text-info">{{ job_detail.statusname }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-0" v-else-if="job_detail.status_id == 3">
                        <img src="../assets/img/check.png" alt="" class="">
                        <span class="status_text text-success">{{ job_detail.statusname }}</span>
                    </div>
                    <button @click="closeModal" class="btn btn-close"></button>
                </div>
            <div>   
                <div class="jobpad mb-1 p-2">
                    <div class="job_item">
                        <div class="d-flex align-items-center mb-0 justify-content-between">
                            <div class="h5 py-1 text-primary">{{ job_detail.cartypename }}</div>
                            <div class="time_call">
                                <span class="pi pi-clock"></span> {{ job_detail.time_call_time }}
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-0">
                            <span><img src="../assets/img/icon/start.svg" class="pin"></span>
                            <span class="position">{{ job_detail.position_call_name }}</span>
                        </div>
                        <div class="line_time_line"></div>
                        <div class="d-flex align-items-center mb-0">
                            <span><img src="../assets/img/icon/end.svg" class="pin"></span>
                            <span class="position">{{ job_detail.position_send_name }}</span>
                        </div>
                        
                    </div>
                    <div class="pt-3 show_job_detail"  >
                        <div class="job_detail_head" v-show="job_detail && job_detail.itemlist && job_detail.itemlist[0] != ''" >
                            <span class="pi pi-cart-minus" > </span> อุปกรณ์ 
                        </div>
                        <div class="job_detail">
                            <div class="job_detail_item" >
                                <div v-for="item in job_detail.itemlist" :key="item.id">{{ item }}</div>
                            </div>
                        </div>
                        <div class="job_detail_head text-danger"><span class="pi pi-exclamation-triangle"> </span> ข้อควรระวัง</div>
                        <div class="job_detail">
                            <div class="job_detail_item text-danger">
                                {{ job_detail.more }}
                            </div>
                        </div>
                        <hr>
                        <div class="d-flex align-items-top mt-3  ">
                            <div class="fw_bold">ผู้ป่วย : </div>
                            <div class="ms-2">{{ job_detail.hn_name }}</div>
                        </div>
                        <div class="d-flex align-items-top mt-3  ">
                            <div class="fw_bold">หมายเหตุ : </div>
                            <div class="ms-2">{{ job_detail.remark }}</div>
                        </div>
                        
                        <hr>

                        <div class="time_call ">
                            <span class="pi pi-clock"></span> <span class="">{{ job_detail.time_call_th }} 
                                <span class="pi pi-clock"></span>{{ job_detail.time_call_time }}
                            </span>
                        </div>

                    

                    </div>
                    <br>
            </div>
            <div class="footer_job">
                    <div class="row">
                        <div class="col-4">
                            <button class="btn btn-outline-secondary btn-lg btn-rouned w-100 py-3 text-dark" @click="closeModal">ปิด</button>
                        </div>
                        <div class="col-8" v-if="job_detail.status_id == 1">
                            <button class="btn btn-primary btn-rouned btn-lg w-100 py-3" @click="getJob(job_detail.id,'2')">รับงาน</button>
                        </div>
                        <div class="col-8" v-else-if="job_detail.status_id == 2 && job_detail.officer_id == officer_id">
                            <button class="btn btn-warning btn-rouned btn-lg w-100 py-3" @click="getJob(job_detail.id,'3')">ยืนยันเสร็จ</button>
                        </div>

                        <div class="col-8" v-else>
                            <div class="text-dark text-center">
                                {{ job_detail.statusname }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>


export default {
    data (){
        return {
			officer_id: localStorage.getItem('officer_id'),
        }
    },
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        job_detail: {
            type: Object,
            // required: true
        }
    },
    methods: {
        openModal() {
            this.showModal = true; // เปิด modal
        },
        closeModal() {
            this.$emit('close-modal');
        },
        getJob(job_id,status_id){
            let data= {job_id:job_id,status_id:status_id}
            this.$emit('get-job',data);
        }
    }
};
</script>

<style scoped>
.job_modal{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 1000 !important;
    top: 0;
    left: 0;
    /* display: none; */
    display: block;
    outline: 0;
    padding: 8px;
    border-radius: 20px 20px;
    
    transition: 100ms;
    box-shadow: rgba(70, 70, 71, 0.2) 0px 7px 29px 0px;
    
}
.active{
    margin-top:3vh;
}
.inactive {
    margin-top: 110vh ;
}
.btn-close{
    border-radius: 50%;
    background-color: #d4d4d4 !important ;
    padding: 12px;
}
.job_item{
    background-color: #f1f1f1c4 !important;
    border-radius: 8px 8px;
    padding: 10px;
    font-size: 1.20rem !important;
}
.job_item .position{
    font-size: 1.1rem !important;
    color: #000 !important;
    font-weight: 500 !important;
}
.show_job_detail{
    font-size: 1.1rem !important;
}
.job_detail{
    margin-bottom: 12px;
}
.job_detail_head{
    /* color: #000 !important; */
    font-weight: bold !important;
    margin-bottom: 3px;
}
.job_detail .job_detail_item{
    padding-left: 24px !important;
}
.time_call{
    font-size: 0.96rem !important;
    color: #2c2c2c !important;
    align-items: top !important;
}
.status_text{
    font-size: 1.2rem !important;
    font-weight: 600 !important;
    margin-left: 10px;
    padding-top: 4px;
}
.status_text .success{
    color: #06b472 !important;
}
.jobpad{
    height: 75% !important;
    /* background-color: #ffdfdf !important; */
    overflow: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
    /* scollbar */
    scrollbar-color: #dbdbdb #f1f1f1c4;
    padding-bottom: 8px !important;
}
.footer_job{
    bottom: 39px;
    width: 96%;
    position: absolute;
   
}
</style>
